<template>
    <van-popup v-model:show="show" @close="closePop" style="background: rgba(0,0,0,0);">
        <div class="popup-box">
            <div class="content" :class="{ content0: props.data[0].stype == '2-3' }">
                <img v-if="props.data.length > 0 && props.data[0].stype != '2-3'" class="tztopbg"
                    src="@/assets/images/tztopbgotc.png" alt="">
                <!-- 弹窗标题和内容 -->
                <div v-if="props.data.length > 0 && props.data[0].stype == '2-1'">
                    <div class="h1">{{ t('notifyPopupOtc.a1') }}</div>
                    <p class="con" style="margin: 20px 0;" v-if="props.data.length > 1">{{ t('notifyPopupOtc.a2') }}</p>
                    <p class="con" v-else>{{ t('notifyPopupOtc.a3') }}</p>
                </div>
                <div v-if="props.data.length > 0 && props.data[0].stype == '2-2'">
                    <div class="h1">{{ t('notifyPopupOtc.d3') }}</div>
                    <p class="con" style="margin: 20px 0;" v-if="props.data.length > 1">{{ t('notifyPopupOtc.d1') }}</p>
                    <p class="con" v-else>{{ t('notifyPopupOtc.d2') }}</p>
                </div>
                <div v-if="props.data.length > 0 && props.data[0].stype == '2-3'">
                    <div class="h1">{{ t('notifyPopupOtc.d6') }}</div>
                    <p class="con" style="margin: 20px 0;" v-if="props.data.length > 1">{{ t('notifyPopupOtc.d4') }}</p>
                    <p class="con" v-else>{{ t('notifyPopupOtc.d5') }}</p>
                </div>
                <!-- 弹窗标题和内容 end -->
                <!-- 订阅推送 -->
                <div v-if="props.data.length == 1 && props.data[0].stype == '2-1'">
                    <div class="popTextInfo">
                        <div>{{ t('notifyPopupOtc.a4') }} </div>
                        <div class="rg">
                            <span>{{ props.data[0].content.stock_name }}</span>
                        </div>
                    </div>
                    <div class="popTextInfo">
                        <div>{{ t('notifyPopupOtc.a5') }}</div>
                        <div class="rg">
                            <span>{{ Number(props.data[0].content.price).toFixed(2) }} {{
                                formatUnit(props.data[0].content.currency) }}</span>
                            <div class="yval" v-if="props.data[0].content.currency == 'USD'"> ≈
                                {{ exchangeRateConvert(props.data[0].content.price, mainStore.rate) }} ARS</div>
                        </div>
                    </div>
                    <div class="popTextInfo">
                        <div>{{ t('notifyPopupOtc.a6') }}</div>
                        <div class="rg">
                            <span>{{ Number(props.data[0].content.market_price).toFixed(2) }} {{
                                formatUnit(props.data[0].content.currency) }}</span>
                            <div class="yval" v-if="props.data[0].content.currency == 'USD'"> ≈
                                {{ exchangeRateConvert(props.data[0].content.market_price, mainStore.rate) }} ARS</div>
                        </div>

                    </div>
                    <div class="djs">{{ t('notifyPopupOtc.a8') }}<br></br><span>{{ timeTextVal }}</span></div>
                </div>
                <!-- 分配成功 -->
                <div v-if="props.data.length == 1 && props.data[0].stype == '2-2'">
                    <div class="popTextInfo">
                        <div>{{ t('notifyPopupOtc.a9') }}</div>
                        <div class="rg">
                            <span>{{ props.data[0].content.stock_name }}</span>
                        </div>
                    </div>
                    <div class="popTextInfo">
                        <div>{{ t('notifyPopupOtc.a11') }} </div>
                        <div class="rg">
                            <span>{{ Number(props.data[0].content.price).toFixed(2) }} {{
                                formatUnit(props.data[0].content.currency) }}</span>
                            <div class="yval" v-if="props.data[0].content.currency == 'USD'"> ≈ {{
                                exchangeRateConvert(props.data[0].content.price, mainStore.rate) }} ARS</div>
                        </div>
                    </div>
                    <div class="popTextInfo">{{ t('notifyPopupOtc.a12') }}<span>{{ props.data[0].content.number
                            }}</span>
                    </div>
                    <div class="popTextInfo">{{ t('notifyPopupOtc.a13') }} <span>{{ props.data[0].content.symbol
                            }}</span>
                    </div>
                    <div class="popTextInfo">{{ t('notifyPopupOtc.a14') }}<span style="font-size: 12px;">{{
                        props.data[0].content.order_sn
                            }}</span></div>
                    <div class="popTextInfo">{{ t('notifyPopupOtc.a15') }} <span>{{ props.data[0].content.sub_time
                            }}</span>
                    </div>
                </div>
                <!-- 驳回 -->
                <div v-if="props.data.length == 1 && props.data[0].stype == '2-3'">
                    <p class="popTextInfo">{{ t('notifyPopupOtc.a9') }}<span>{{ props.data[0].content.stock_name
                    }}</span></p>

                    <div class="popTextInfo">
                        <div>{{ t('notifyPopupOtc.a18') }}</div>
                        <div class="rg">
                            <span>{{ Number(props.data[0].content.price).toFixed(2) }} {{
                                formatUnit(props.data[0].content.currency) }}</span>
                            <div class="yval" v-if="props.data[0].content.currency == 'USD'"> ≈ {{
                                exchangeRateConvert(props.data[0].content.price, mainStore.rate) }} ARS</div>
                        </div>
                    </div>
                    <p class="popTextInfo">{{ t('notifyPopupOtc.a19') }}<span style="font-size: 12px;">{{
                        props.data[0].content.order_sn }}</span></p>
                    <p class="popTextInfo">{{ t('notifyPopupOtc.a20') }}
                        <span style="color: red;">
                            {{ t('notifyPopupOtc.d7') }}
                        </span>
                    </p>
                    <p class="popTextInfo">{{ t('notifyPopupOtc.a21') }} <span>{{ props.data[0].content.user_remark
                    }}</span></p>
                </div>
                <van-button type="default" class="btn" @click="handleReceive">{{ t('notifyPopup.a3') }}</van-button>
            </div>
        </div>
    </van-popup>
</template>
<script setup>
import { exchangeRateConvert } from "@/utils/globalMethods"
import { formatUnit } from "@/utils/globalMethods"
import { ref, watch } from 'vue'
import { useCountdown } from "@/utils/useCountdown2";
import { readNoticeApi } from "@/api"
import { showToast, showSuccessToast } from 'vant';
import { useRouter } from 'vue-router';
import { useI18n } from "vue-i18n"
import { useMainStore } from "@/store"
const mainStore = useMainStore()
const { t } = useI18n()
const router = useRouter()

/**
 * Props
 */
const props = defineProps({
    modelValue: { type: Boolean, default: false },   // v-model:show
    data: {
        type: Array,
        default: () => ([])
    }
})

/**
 * Emits
 */
const emit = defineEmits(["update:modelValue"])

const show = ref(props.modelValue)

// 同步 v-model:show
watch(
    () => props.modelValue,
    (val) => {
        show.value = val
    }
)
const timeTextVal = ref('')

watch(show, (val) => {
    emit("update:modelValue", val)
})
const end = computed(() => props.data[0]?.content.end)
watch(end, (val) => {
    if (val) {
        const { timeText, start } = useCountdown(props.data[0]?.content.end, t);
        start();
        timeTextVal.value = timeText
    }
}, {
    immediate: true
})


/**
 * 点击按钮
 */
const read = async (idVal) => {
    try {
        const res = await readNoticeApi({
            id: idVal
        });
    } catch (error) {
        console.error(error);
    }
};


function handleReceive() {
    const ids = props.data.map(item => item.id)
    const idString = ids.join(',')
    read(idString)
    mainStore.setIsOtcTc(true)
    if (props.data.length == 1) {
        if (props.data[0].stype == '2-3') {
            router.push('/otc?active=3')
        } else if (props.data[0].stype == '2-2') {
            router.push('/otc?active=1')
        } if (props.data[0].stype == '2-1') {
            router.push('/otc?active=0')
        }
    } else {
        router.push('/otc')
    }
}
function closePop() {
    const ids = props.data.map(item => item.id)
    const idString = ids.join(',')
    // console.log(idString);

    // read(idString)
    mainStore.setIsOtcTc(true)
}


</script>
<style scoped lang="scss">
.popup-box {
    width: 90vw;
    max-width: 350px;
    padding-top: 44px;

    .content {
        border-radius: 20px;
        background-color: #FFF;
        position: relative;
        padding-top: 44px;
        padding: 50px 16px 20px 16px;
        background-image: url("@/assets/images/tzbg.png");
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: top;

        &.content0 {
            padding-top: 20px;
        }

        .tztopbg {
            width: 146px;
            position: absolute;
            left: 0;
            right: 0;
            top: -75px;
            margin: auto;
        }

        .h1 {
            color: #000;
            text-align: center;
            font-family: "Microsoft YaHei UI";
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-bottom: 12px;
        }

        .con {
            color: #666;
            text-align: center;
            font-family: "Microsoft YaHei UI";
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;
            margin-bottom: 8px;
        }

        .popTextInfo {
            display: flex;
            justify-content: space-between;
            font-size: 12px;
            margin-bottom: 8px;
            color: #000;

            .rg {
                text-align: right;
            }

            span {
                color: #333;
                font-size: 12px;
            }

            .yval {
                font-size: 11px;
                color: #888c9f;
                margin-top: 0px;
                font-weight: 400;
            }
        }

        .djs {
            text-align: center;
            color: #666;
            text-align: center;
            font-family: "Microsoft YaHei UI";
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;

            span {
                color: #e52d03;
            }
        }

        .btn {
            margin-top: 16px;
            width: 100%;
            border-radius: 10px;
            background: #2969FF;
            border-color: #2969FF;
            color: #FFF;
            text-align: center;
            font-family: "Microsoft YaHei UI";
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }
    }
}
</style>